module.exports = __webpack_public_path__ + "static/media/userDefaultLogo.ff03fa52.svg";